import api from 'api';

import type ResponseResult from 'types/response';

import type { BridgeSendRequest, BridgeCheckResponse } from 'types/bridge';

export const bridgeSend = ({ tokenId }: BridgeSendRequest) =>
  api.post('/bridge/send?network=ethereum', { tokenId });

export const bridgeReceive = () => api.post('/bridge/receive?network=polygon');

export const bridgeCheck = (): Promise<ResponseResult<BridgeCheckResponse>> =>
  api.get(`/bridge?network=polygon`);
